@if (hasHidePermission) {
  <button
    class="community-feed-item-hide"
    [class.active]="isHidden"
    [attr.aria-label]="ariaLabel"
    (click)="hidePopover()">
    <i class="material-icons hide-icon" aria-hidden="true">{{ isHidden ? 'visibility' : 'visibility_off' }}</i>
  </button>
}